import { abyssColors } from '@/theme/colors';
import { IconButton, styled as muiStyled } from '@mui/material';

export const StyledRemoveButton = muiStyled(IconButton)({
  position: 'absolute',
  top: -6,
  right: -6,
  color: 'white',
  backgroundColor: abyssColors.error[500],
  '&:hover': {
    backgroundColor: 'darkred',
  },
  borderRadius: '50%',
  width: 22,
  height: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
